import React, { Component } from 'react';
import '../../css/theme/buttons.css';
import '../../css/components/buttonSelector.css';


interface buttonOption {name: string}
export interface ButtonSelectorProps {
    options: [buttonOption];
    selectedOption: string;
    handleOptionSelected: ((option: buttonOption) => void) | null;
    buttonWidth?: string | number;
    buttonHeight?: string | number;
}

class ButtonSelector extends Component<ButtonSelectorProps> {
    buttonStyle = () => {
        return {
            marginTop: "14px",
            width: this.props.buttonWidth,
            height: this.props.buttonHeight,
            paddingTop: "1.2px",
            fontSize: "14px"
        };
    };

    getOptionName(option: any) {
        return (option && Object.prototype.hasOwnProperty.call(option, "name")) ? option.name : option;
    }

    optionsEqual(option1: any, option2: any) {
        return this.getOptionName(option1) === this.getOptionName(option2);
    }

    optionClassName = (option: buttonOption, optionIndex: number) => {
        const firstOption = optionIndex === 0;
        const lastOption = optionIndex === this.props.options.length - 1;

        const positionClassName = firstOption ? "ss-button-primary-l" : lastOption ? "ss-button-primary-r" : "ss-button-primary-middle";
        const selectedClassName = this.optionsEqual(option, this.props.selectedOption) ? " ss-button-primary-selected" : " ss-button-primary-deselected";

        return positionClassName + " " + selectedClassName;
    };

    handleButtonClick = (option: buttonOption) => {this.props.handleOptionSelected && this.props.handleOptionSelected(option)};

    static getDisplayValue (option: buttonOption | any):string {
        return (option && Object.prototype.hasOwnProperty.call(option, "name")) ? option.name : option;
    }

    render() {
        return (
            <div className="button-selector">
                {
                    this.props.options.map((option, index) =>
                        <button key={index}
                                type="button"
                                className={this.optionClassName(option, index)}
                                onClick={() => this.handleButtonClick(option)}>
                            {ButtonSelector.getDisplayValue(option)}
                        </button>
                    )
                }
            </div>
        )
    }
}

export default ButtonSelector;